import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../public/assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-7bb5ffa6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo-class",
  src: _imports_0,
  alt: "erkoware logo"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_budget_field = _resolveComponent("budget-field")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_header = _resolveComponent("ion-header")!

  return (_openBlock(), _createBlock(_component_ion_header, { class: "header-style" }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_grid, { style: {"width":"100%"} }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, { style: {"height":"var(--header-height)"} }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, null, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _withDirectives(_createVNode(_component_ion_row, { style: {"height":"150px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, {
                "size-md": "2",
                "size-lg": "7",
                "size-xl": "8",
                size: "0",
                style: {"padding-left":"0","padding-right":"0"}
              }),
              _createVNode(_component_ion_col, {
                "size-md": "8",
                "size-lg": "5",
                "size-xl": "4",
                size: "12",
                class: "center",
                style: {"padding":"0"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_budget_field)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 512), [
            [_vShow, _ctx.$route.name === 'Node']
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}